import { gql } from '@apollo/client';

export const ORDENVENTA_FRAGMENT = gql`
  fragment OrdenVentaFragment on OrdenVenta {
    id
    estatus
    estatusPago
    importePagado
    esPublicoGeneral
    fechaCreacion
    ordenCompra
    inventarioId
    correoFacturacion
    comentarios
    fechaEntrega
    direccionEnvioId
    direccionLab
    folioFactura
    fechaFactura
    fechaPago
    direccionEnvioNombre {
      id
      nombreDomicilio
    }
    direccionEnvio {
      id
      calle
      numeroExterior
      colonia
      municipio
      estado
      codigoPostal
    }
    contactoId
    lote
    geolocalizacion
    folio
    fechaCreacion
    total
    subtotal
    subtotal_prod
    iva
    flete
    descuento
    documento {
      id
      key
      nombreArchivo
      contentType
      url
    }
    ordenVentaProductos {
      id
      cantidad
      comentarios
      subtotal
      subtotal_prod
      flete
      fleteUnitario
      iva
      descuento
      descuentoDato
      total
      unidadMedidaId
      precioUnitario
      estatusProducto
      cantidadEntregada
      ordenVentaId
      unidadMedida {
        id
        nombre
      }
      producto {
        id
        codigo
        nombre
        marca
        descripcion
        empaque
        cantidad
        unidadMedidaPresentacion {
          id
          nombre
          acronimo
        }
      }
    }
    contacto {
      id
      nombre
      apellidos
      prefijo
      telefono
      correo
    }
    desarrollo {
      id
      folio
      prospectoId
      razonSocial
      patrocinio
      prospecto {
        id
        nombre
        apellidos
        ocupacion
        datosFiscalId
        atendidoPorId
        nombreComercial
        razonSocialFiscal
        diasCredito
        rfc
        direccionFiscal {
          id
          direccionTipo
          comentarios
          direccion {
            id
            codigoPostal
            numeroExterior
            numeroInterior
            calle
            colonia
            municipio
            estado
          }
        }
      }
      usuario {
        id
        persona {
          nombre
          apellidoPaterno
          apellidoMaterno
        }
      }
    }
    cotizacion {
      id
      folio
      prospectoId
      direccionLab
      razonSocial
      direccionEnvio {
        id
        nombreDomicilio
      }
      prospecto {
        id
        nombre
        apellidos
        ocupacion
        datosFiscalId
        atendidoPorId
        nombreComercial
        razonSocialFiscal
        diasCredito
        direccionFiscal {
          id
          direccionTipo
          comentarios
          direccion {
            id
            codigoPostal
            numeroExterior
            numeroInterior
            calle
            colonia
            municipio
            estado
          }
        }
      }
      usuario {
        id
        persona {
          nombre
          apellidoPaterno
          apellidoMaterno
        }
      }
    }
  }
`;

export const OBTENER_SALIDA_PRODUCTOS = gql`
  query ($productoId: ID!, $ordenVentaId: ID!) {
    ordenesVentas {
      obtenerSalidaProductoAsync(
        productoId: $productoId
        ordenVentaId: $ordenVentaId
      ) {
        id
        cantidad
        fechaSalida
        almacenId
        ordenVentaId
        productoId
        telefono
        chofer
      }
    }
  }
`;

export const OBTENER_PAGINADO_SALIDA_PRODUCTO = gql`
  query OVPage(
    $query: QueryInput!
    $vendorId: ID
    $empresa: RazonSocialEnum
    $estatus: OrdenVentaEstatus
    $fechaInicio: Date
    $fechaFin: Date
  ) {
    ordenesVentas {
      obtenerPaginadoSalidaProducto(
        query: $query
        vendorId: $vendorId
        empresa: $empresa
        estatus: $estatus
        fechaInicio: $fechaInicio
        fechaFin: $fechaFin
      ) {
        totalItems
        items {
          ...OrdenVentaFragment
        }
      }
    }
  }
  ${ORDENVENTA_FRAGMENT}
`;

export const OBTENER_PAGINADO_FAC = gql`
  query OVPage(
    $query: QueryInput!
    $vendorId: ID
    $empresa: RazonSocialEnum
    $estatus: OrdenVentaEstatus
    $fechaInicio: Date
    $fechaFin: Date
  ) {
    ordenesVentas {
      obtenerPaginadoFactura(
        query: $query
        vendorId: $vendorId
        empresa: $empresa
        estatus: $estatus
        fechaInicio: $fechaInicio
        fechaFin: $fechaFin
      ) {
        totalItems
        items {
          ...OrdenVentaFragment
        }
      }
    }
  }
  ${ORDENVENTA_FRAGMENT}
`;

export const OBTENER_PAGINADO_OV = gql`
  query OVPage(
    $query: QueryInput!
    $vendorId: ID
    $estatus: OrdenVentaEstatus
    $fechaInicio: Date
    $fechaFin: Date
  ) {
    ordenesVentas {
      obtenerPaginado(
        query: $query
        vendorId: $vendorId
        estatus: $estatus
        fechaInicio: $fechaInicio
        fechaFin: $fechaFin
      ) {
        totalItems
        items {
          ...OrdenVentaFragment
        }
      }
    }
  }
  ${ORDENVENTA_FRAGMENT}
`;

export const OBTENER_INVENTARIOS = gql`
  query inventarios {
    ordenesVentas {
      obtenerTodosInventarios {
        id
        nombre
      }
    }
  }
`;

export const OBTENER_ORDEN_VENTA_POR_ID = gql`
  query ($id: ID!) {
    ordenesVentas {
      obtenerPorId(id: $id) {
        ...OrdenVentaFragment
      }
    }
  }
  ${ORDENVENTA_FRAGMENT}
`;
export const OBTENER_ORDEN_VENTA_POR_ID_FACTURA = gql`
  query ($id: ID!) {
    ordenesVentas {
      obtenerPorId(id: $id) {
        id
        total
        importePagado
      }
    }
  }
`;
